import React from 'react';
import {OrderByOptions} from './utilities';
import classNames from 'classnames';
interface SortFormProps {
  sortFilter: string;
  setsortFilter: (sortFilter: string) => void;
  setIsSortOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const SortForm = ({
  sortFilter,
  setsortFilter,
  setIsSortOpen,
}: SortFormProps) => {
  return (
    <div className="flex flex-col w-full items-start px-4 gap-6 py-4">
      {OrderByOptions.map((item, index) => (
        <button
          key={index}
          onClick={() => {
            setsortFilter(item.value);
            setIsSortOpen(false);
          }}
          className={classNames(
            'text-[16px] font-medium',
            {
              'text-primary': item.value === sortFilter,
            },
            {
              'text-gray-5': item.value !== sortFilter,
            },
          )}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

export default SortForm;
